export default __webpack_public_path__ + "static/media/google-icon.aedc5294.svg";